import { setIsLoading } from './set-is-loading';

export const stopLoadingCategory = categoryId => setIsLoading('category', categoryId, false);



// WEBPACK FOOTER //
// ./app/actions/stop-loading-category.js